import React from 'react';
import styled from 'styled-components';
import Up from '../../assets/up.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import ReactCompareImage from 'react-compare-image';
import before from '../../assets/before-sandy.jpg';
import after from '../../assets/after-sandy.jpg';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  
  @media (max-width: 768px) {
    width: 100%;

  }
`;

const Viz = styled.div`
  display: flex;
  width: 100%;

  justify-content: flex-start;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
`;


class CardHurricanes extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
      <ReactCompareImage leftImage={before} rightImage={after} />;

    </Viz>

   <ReusableDetailCard
   trend= {Up}
   metricsm="Intensifying"
   diagnosis="Hurricanes are large, swirling storms that form over warm ocean waters. If a hurricane reaches land, it pushes a wall of ocean water ashore (storm surge). Heavy rain and storm surge from a hurricane can cause flooding (NASA). Pictured- impact of hurricane Sandy (2012) on a Staten Island marina."
   prediction="Warm ocean waters provide the energy a storm needs to become a hurricane (NASA). As the oceans warm, storms are predicted to become more intense and destructive."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />
</Container>


  );
 }
}
export default CardHurricanes;
